import { useState } from "react";
import PageHeader from "../../Component/Common/PageHeader";
import MultiButton from "../../Component/extra/MultiButton";
import ManageShorts from "./ManageShorts";
import dayjs from "dayjs";
import { useSelector } from "react-redux";
import ShortComment from "./ShortComment";
import NewShortAdd from "../../Component/dialogue/NewShortAdd";

export default function ShortsPage() {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Manage Shorts");
  const [startDate, setStartDate] = useState("All");
  const [endDate, setEndDate] = useState("All");
  const { dialogueType } = useSelector((state) => state.dialogue);

  const startDateFormat = (startDate) => {
    return startDate && dayjs(startDate).isValid()
      ? dayjs(startDate).format("YYYY-MM-DD")
      : "All";
  };
  const endDateFormat = (endDate) => {
    return endDate && dayjs(endDate).isValid()
      ? dayjs(endDate).format("YYYY-MM-DD")
      : "All";
  };

  const startDateData = startDateFormat(startDate);
  const endDateData = endDateFormat(endDate);

  return (
    <div className="userPage videoPage">
      <div
        style={{
          display: `${dialogueType === "editShort" ? "none" : "block"}`,
        }}
      >
        <PageHeader
          heading={"Welcome Admin"}
          subHeading={"Shorts"}
          showDateRange={true}
          startDate={startDate}
          endDate={endDate}
          setStartDate={setStartDate}
          setEndDate={setEndDate}
        />

        <MultiButton
          label={["Manage Shorts", "Manage Short Comments", "Import Shorts"]}
          setMultiButtonSelect={setMultiButtonSelect}
          multiButtonSelect={multiButtonSelect}
        />

        {multiButtonSelect == "Manage Shorts" && (
          <ManageShorts endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Manage Short Comments" && (
          <ShortComment endDate={endDateData} startDate={startDateData} />
        )}
        {multiButtonSelect == "Import Shorts" && (
          <NewShortAdd
            setMultiButtonSelect={setMultiButtonSelect}
            multiButtonSelect={multiButtonSelect}
          />
        )}
      </div>
      {dialogueType === "editShort" && <NewShortAdd />}
    </div>
  );
}
